import React, {useState} from 'react';
import {CSVLink} from 'react-csv';
import {flatten} from 'flat';
import {Button, Select} from 'antd';

const JsonToCsv = ({jsonData}) => {
  const [flattenedJson, setFlattenedJson] = useState<any[]>([]);
  const [selectedHeaders, setSelectedHeaders] = useState<string[]>([]);
  const [allHeaders, setAllHeaders] = useState<string[]>([]);

  const handleFlatten = () => {
    const flatJson = jsonData.map((item) => flatten(item));
    setFlattenedJson(flatJson);
    const allKeys = flatJson.reduce((keys, currentItem) => {
      return [...new Set([...keys, ...Object.keys(currentItem)])];
    }, []);
    setAllHeaders(allKeys);
  };

  return (
    <div>
      <Button onClick={handleFlatten}>Download CSV</Button>
      {flattenedJson.length > 0 && (
        <div>
          {/* antd's Select handles search-filtering of options natively, so the
              manual searchQuery/filteredHeaders state from the MUI Autocomplete
              version isn't needed anymore. */}
          <Select
            mode="multiple"
            showSearch
            value={selectedHeaders}
            onChange={(value) => setSelectedHeaders(value)}
            options={allHeaders.map((header) => ({label: header, value: header}))}
            placeholder="Search headers"
            style={{width: '100%'}}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />

          <Button onClick={() => setSelectedHeaders(allHeaders)}>Select All</Button>
          <Button onClick={() => setSelectedHeaders([])}>Deselect All</Button>
        </div>
      )}

      {selectedHeaders.length > 0 && (
        <CSVLink
          data={flattenedJson.map((row) => {
            const newRow = {};
            selectedHeaders.forEach((header) => {
              newRow[header] = row[header];
            });
            return newRow;
          })}
          headers={selectedHeaders.map((header) => ({label: header, key: String(header)}))}
          filename="data.csv">
          <Button>Download</Button>
        </CSVLink>
      )}
    </div>
  );
};

export default JsonToCsv;
